import {toast} from "react-toastify";

export default {
    token: localStorage.getItem("token") ? localStorage.getItem("token").length > 3 ? localStorage.getItem("token") : "" : "",
    api: "https://api.ghestitak.ir",

    smsPatterns: [
        {
            p: "4a8ayjc3o9t80tj",
            t: "%name% عزیز! احراز هویت شما رد شد مجدداً اقدام فرمائید. تکین آنوش"
        },
        {
            p: "9na50hcvdylu2r6",
            t: "%name% عزیز درصورت عدم تکمیل فرآیند، ظرف یک هفته آینده حساب کاربری شما حذف خواهد شد. تکین آنوش"
        },
        {
            p: "jtqk55h787svw4c",
            t: "%name% عزیز، لطفاً جهت تکمیل فرایند ثبت نام به پنل کاربری خود مراجعه فرمایید. تکین آنوش"
        },
        {
            p: "q1qgw3a16h1w8i5",
            t: "%name% عزیز، پس از انتخاب طرح پرداخت خود را نهایی کنید. تکین آنوش"
        },
        {
            p: "toj2kospzmr92v6",
            t: "%name% عزیز، لطفاً اعتبارسنجی خود را به تاریخ روز بارگذاری نمایید. تکین آنوش"
        },
        {
            p: "crdxo0jmc0bl5pd",
            t: "%name% عزیز، لطفاً فیلدهای مربوطه را به صورت دقیق و کامل ثبت نمایید. تکین آنوش"
        },
        {
            p: "vq3m7282e2n1imp",
            t: "%name% عزیز، مشخصات شما ناقص می باشد. تکین آنوش"
        }
    ],

    handleError: (err) => {
        let error = "";
        if (err) {
            if (err.response) {
                if (err.response) {
                    if (err.response.data) {
                        const {message} = err.response.data;
                        if (message) {
                            error = message;
                        }
                    }
                }
            }
        }
        if (error === "") {
            error = "خطایی رخ داده است!"
        }

        toast.error(error);
        return error;
    },

    hasAccess: (permissions, permission) => {
        return permissions.length === 0 || permissions.includes(permission);
    },
    scrollTop: () => {
        try {
            if (window) {
                window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
            }
        } catch (err) {
        }
    },
    priceFormatter: (price = "") => {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    getStringValue: (str = "", def = "") => {
        return str ? str.toString().trim() : def;
    },
    isFa: (str = "") => {
        let isFaString = false;
        if (str.includes("ا") ||
            str.includes("ب") ||
            str.includes("پ") ||
            str.includes("ت") ||
            str.includes("ث") ||
            str.includes("ج") ||
            str.includes("چ") ||
            str.includes("ح") ||
            str.includes("خ") ||
            str.includes("ک") ||
            str.includes("ل") ||
            str.includes("م") ||
            str.includes("ی") ||
            str.includes("آ") ||
            str.includes("د") ||
            str.includes("ذ") ||
            str.includes("ر") ||
            str.includes("ز") ||
            str.includes("ش") ||
            str.includes("س") ||
            str.includes("ص") ||
            str.includes("ض") ||
            str.includes("ع") ||
            str.includes("غ") ||
            str.includes("ن") ||
            str.includes("و")) {
            isFaString = true;
        }

        return isFaString;
    },
    decodeBase64: (base64String = "") => {
        base64String = base64String ? base64String.toString() : "";
        try {
            const binary = atob(base64String);
            const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
            return new TextDecoder().decode(bytes);
        } catch (error) {
            return null;
        }
    },
    getEstelamKeyName: (key = "") => {
        key = key ? key.toString().trim() : "";
        key = key.replace(/\_/g, "");
        switch (key) {
            case "db":
                return "مرجع";
            case "fullname":
                return "نام و نام خانوادگی";
            case "name":
            case "firstname":
                return "نام";
            case "lastname":
                return "نام خانوادگی";
            case "fathername":
                return "نام پدر";
            case "address":
                return "آدرس";
            case "phonenumber":
            case "phone":
            case "mobile":
                return "شماره موبایل";
            case "tel":
                return "شماره";
            case "age":
                return "سن";
            case "birthdate":
                return "تاریخ تولد (سن)";
            case "cardno":
                return "شماره کارت";
            case "acountnumber":
                return "شماره حساب";
            case "nationalcode":
            case "nationalid":
                return "کد ملی";
            case "accountnumber":
                return "شماره حساب";
            case "email":
            case "useremailaddress":
                return "ایمیل";
            case "cardnumber":
                return "شماره کارت";
            case "id":
                return "شناسه";
            case "username":
                return "نام کاربری";
            case "latitude":
                return "عرض جغرافیایی";
            case "longitude":
                return "طول جغرافیایی";
            case "cityname":
            case "city":
                return "شهر";
            case "province":
            case "provincename":
                return "استان";
            case "birthdateprovince":
            case "birthprovince":
                return "استان محل تولد";
            case "birthcity":
                return "شهر محل تولد";
            default:
                return key;
        }
    },
    getEstelamColor: (key = "") => {
        key = key ? key.toString().trim() : "";
        if (["phone", "phonenumber", "nationalcode", "nationalid", "tel", "email", "mobile"].includes(key)) {
            return "#0a3ec5";
        }
        if (["name", "fullname", "firstname", "lastname"].includes(key)) {
            return "#ce4f00";
        }
        if (key === "db") {
            return "#b41c1c";
        }
        return "#313131";
    }
}